<template>
  <div class="allocateranking">
    <div class="con">
      <div class="left-tree">
        <div class="filterText">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </div>
        <div class="scroll" style="width:100%;height:92%">
          <el-scrollbar style="height:100%;width: 100%;">
            <el-tree :data="leftData" ref="leftTree" @node-click="leftTreeClick" :highlight-current="true"
              :expand-on-click-node="true" node-key="id" :default-expanded-keys="defaultExpanded"
              :current-node-key='defaultDevice' :filter-node-method="filterNode">
              <span class="custom-tree-node" slot-scope="{node}" style="display: flex;align-items: center;">
                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;"
                  v-if="node.data.unitName" />
                <img src="../../../public/static/image/elTree/group.png" style="margin-right: 2px;" v-else />
                <span style="padding-left: 5px;">{{node.data.modelName}} <span v-if="firstItem != node.data.id">({{
                    node.data.modelType | date_format}})</span></span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="right-con">
        <div class="newtable-title">
          <div class="left-t">
            <span>模型排名</span>
          </div>

        </div>
        <div class="serch-btn">
          <div class="terms">
            <el-select v-model="timeType" placeholder="请选择" style="width: 1.6rem;margin-right: 20px;"
              @change='changeTimeType'>
              <el-option label="日" value="DAY"> </el-option>
              <el-option label="月" value="MON"> </el-option>
              <el-option label="年" value="YEAR"> </el-option>
            </el-select>
            <el-date-picker class="picker" v-model="dateValue" type="date" placeholder="请选择日期" v-if="dateType == 'DAY'"
              :picker-options="pickerOptions"></el-date-picker>
            <el-date-picker class="picker" v-model="dateValue" type="month" placeholder="请选择月份" v-if="dateType == 'MON'"
              :picker-options="pickerOptions"></el-date-picker>
            <el-date-picker class="picker" v-model="dateValue" type="year" placeholder="请选择年份" v-if="dateType == 'YEAR'"
              :picker-options="pickerOptions"></el-date-picker>
            <el-button type="primary" plain style="margin-left:20px;position: relative;top: 1px;" @click="getList"
              class="search-btn">查询</el-button>
          </div>

        </div>
        <div class="mychart">
          <div id="proportion" style="width:110%;height:100%"></div>

        </div>
        <div class="mytable">
          <!-- 表格 -->
          <el-table stripe :data="tableData" border style="width: 100%" :max-height="heights" v-loading="loading">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="90" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="名称" prop="name" width="180"> </el-table-column>
            <el-table-column v-for="(item,index) in columns" :key='index' :prop="item.key" :label="item.name"
              align="center" width="90"> </el-table-column>
          </el-table>
        </div>
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {findModelTree,dissipaEnergy} from "../../api/dissipation";
  let proportion;
  export default {
    data () {
      return {
        heights: document.getElementById('app').clientHeight-670,
        loading: false,
        radio: "1",
        filterText: "",//树形结构搜索
        leftData: [],//树形结构数据
        unitItem: {},
        defaultExpanded: [],
        defaultDevice: "",
        firstItem: "",
        //柱状图
        proportionData: {
          grid: {
            top: "8%",
            left: 100,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            top: '-5',
            right: "150",
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },

              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },

          },
          legend: {
            data: ["工序"],
            bottom: 0,
            icon: "rect", //  
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            textStyle: {
              lineHeight: 56,
              fontSize: 14,
            },
            itemGap: 50, // 设置间距
          },

          xAxis: {
            splitLine: {
              //网格线
              show: true,
            },
            type: "category",

            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,

            },
            axisLine: {
              show: false,
            },
            z: 99,
            data: [
              "0时",
              "1时",
              "2时",
              "3时",
              "4时",
              "5时",
              "6时",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "",
              data: [],
              type: "bar",
              stack: "total",

              emphasis: {
                focus: "series",
              },
            },

          ],
        },
        //表格
        tableData: [],
        columns: [],
        timeType: "DAY",
        dateValue: new Date(),
        dateType: "DAY",
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },

      };
    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      }
    },
    watch: {
      filterText (val) {
        this.$refs.leftTree.filter(val);
      },
      unitId () {
        this.findUnitInfoFun()
      }
    },

    mounted () {
      for(let i=0;i<12;i++) {
        this.columns.push({
          'name': `${i}时`
        })
      }
      this.findUnitInfoFun()
      this.init()


    },

    methods: {
      filterNode (value,data) {
        if(!value) return true;
        return data.modelName.indexOf(value)!==-1;
      },
      //左边树形结构数据
      findUnitInfoFun () {
        // return
        var d={
          unitId: this.unitId.id
        }
        findModelTree(d).then(res => {
          if(res.code==200) {
            var arr=[res.data]
            arr[0].modelName=arr[0].unitName
            arr[0].id=arr[0].unitId
            this.firstItem=arr[0].id
            arr[0].parentId=0
            this.leftData=arr
            if(JSON.stringify(this.unitItem)=="{}") {
              this.unitItem=arr[0].children[0]
            }
            this.defaultDevice=this.unitItem.id
            this.defaultExpanded=[this.unitItem.id]
            this.$nextTick(() => {
              //默认选中
              this.$refs['leftTree'].setCurrentKey(this.defaultDevice);
            })
            this.getList()
          }
        })

      },

      //左边数据结构点击
      leftTreeClick (item) {
        this.unitItem=item
        this.getList()
      },
      changeTimeType (val) {
        this.dateType=val
      },
      //获取数据
      getList () {
        var d={
          'dateType': this.timeType,
          'modelId': this.unitItem.id,
          'searchDate': this.dateValue.getTime(),
        }
        var timerType=""
        if(this.timeType=='DAY') {
          timerType='时'
        } else if(this.timeType=='MON') {
          timerType='日'
        } else {
          timerType='月'
        }
        this.loading=true
        dissipaEnergy(d).then(res => {
          // console.log("数据",res);

          if(res.code==200) {
            this.proportionData.series[0].data=[]
            this.proportionData.xAxis.data=[]
            this.columns=[]
            var list=res.data
            var titleName=`${this.unitItem.modelName}(${this.unitItem.modelType})`
            this.tableData=[{name: titleName}]
            this.proportionData.legend.data=[titleName]
            this.proportionData.series[0].name=titleName
            for(let k in list) {
              this.proportionData.series[0].data.push(list[k])
              this.proportionData.xAxis.data.push(k+timerType)
              this.tableData[0][k]=list[k]
              this.columns.push({
                'name': k+timerType,
                'key': k,
              })
            }
            proportion.setOption(this.proportionData,true);
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查询失败，请检查配置！！')
            this.loading=false
          }

        })

      },
      //图表初始化
      init () {
        proportion=echarts.init(document.getElementById("proportion"));
        proportion.setOption(this.proportionData,true);
        //  proportion.resize({ height: 450 });
      }

    },
    //过滤器
    filters: {


      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        var str=""
        if(value=='AREA') {
          str='区域'
        } else if(value='PROCESS') {
          str='工序'
        } else if(value='PRODUCTION') {
          str='产线'
        } else if(value='WORKSHOP') {
          str='车间'
        } else if(value='PT') {
          str='点位'
        }
        return str
      },
    }
  };
</script>

<style lang="scss" scoped>
  .allocateranking {
    width: 100%;
    // height: 100%;
    padding: 8px;

    .con {
      width: 100%;
      height: 100%;
      display: flex;
      box-sizing: border-box;
      overflow: hidden;
    }

    .left-tree {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;
      flex-shrink: 0;
      box-sizing: border-box;

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }

    }

    .right-con {
      // flex-grow:1;
      height: 100%;
      // width: 100%;
      width: calc(100% - 3rem);
      background-color: #fff;
      padding: 12px 20px;
      box-sizing: border-box;
      position: relative;

      .serch-btn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .mychart {
        width: 100%;
        height: 49%;
        margin-bottom: 10px;
      }

      .mytable {
        width: 100%;
        margin-top: 20px;
      }

      /deep/.el-loading-mask {
        top: 58px;
      }

    }
  }
</style>